// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Plan of the build plan (de:Zugbidlungsplan (ZBP) of vehicle-type such as a car (data quality might not be guaranted properly for all `TrainElement's`).
 * @export
 * @interface DeckPlan
 */
export interface DeckPlan {
    /**
     * Vehicle-type resp. technical expression of a physical `TrainElement` (car, wagon) within a `CompoundTrain` (aka de:FahrzeugType gemäss Zugbildungsplan (ZBP)), source CERES.
     * @type {string}
     * @memberof DeckPlan
     */
    typeTechnical?: string;
    /**
     * Popular train-model like 'Dosto', 'Domino', 'ICN', .. Relates to `typeTechnical`.
     * @type {string}
     * @memberof DeckPlan
     */
    typeAdvertised?: string;
    /**
     * Related to `typeAdvertised`. Specialized sub-site of [unsere Züge](https://www.sbb.ch/de/bahnhof-services/waehrend-der-reise/unsere-zuege.html), [über uns - Flotte](https://www.bls.ch/de/unternehmen/ueber-uns/flotte#/), [Fahrzeuge - Flotte](https://www.sob.ch/dienstleistungen/fahrzeuge/flotte).
     * @type {string}
     * @memberof DeckPlan
     */
    typeAdvertisedLink?: string;
    /**
     * May contain a concrete descrpition of about how many decks (aka floors) a car may provide.
     * @type {string}
     * @memberof DeckPlan
     */
    buildCategory?: string;
}

/**
 * Check if a given object implements the DeckPlan interface.
 */
export function instanceOfDeckPlan(value: object): value is DeckPlan {
    return true;
}

export function DeckPlanFromJSON(json: any): DeckPlan {
    return DeckPlanFromJSONTyped(json, false);
}

export function DeckPlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeckPlan {
    if (json == null) {
        return json;
    }
    return {
        
        'typeTechnical': json['typeTechnical'] == null ? undefined : json['typeTechnical'],
        'typeAdvertised': json['typeAdvertised'] == null ? undefined : json['typeAdvertised'],
        'typeAdvertisedLink': json['typeAdvertisedLink'] == null ? undefined : json['typeAdvertisedLink'],
        'buildCategory': json['buildCategory'] == null ? undefined : json['buildCategory'],
    };
}

  export function DeckPlanToJSON(json: any): DeckPlan {
      return DeckPlanToJSONTyped(json, false);
  }

  export function DeckPlanToJSONTyped(value?: DeckPlan | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'typeTechnical': value['typeTechnical'],
        'typeAdvertised': value['typeAdvertised'],
        'typeAdvertisedLink': value['typeAdvertisedLink'],
        'buildCategory': value['buildCategory'],
    };
}

